import { cn } from "@postdaily/ui/lib/utils"

function Spinner({ className, style, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      role="status"
      aria-label="Loading"
      className={cn("text-foreground size-4", className)}
      style={{ animation: "spin 0.8s steps(8, end) infinite", ...style }}
      {...props}
    >
      {Array.from({ length: 8 }).map((_, i) => (
        <rect
          key={i}
          x="11"
          y="2.5"
          width="2"
          height="5"
          rx="1"
          fill="currentColor"
          fillOpacity={+(1 - (i / 8) * 0.85).toFixed(2)}
          transform={`rotate(${i * 45} 12 12)`}
        />
      ))}
    </svg>
  )
}

export { Spinner }
